/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FehlerlistenEintrag } from '../../models/fehlerlisten-eintrag';

export interface GetAllFehlerlistenEintraege$Plain$Params {
  Datum?: string;
  IsNeedsCorrection?: string;
  Vorname?: string;
  Nachname?: string;

/**
 * Nummer der Seite die angezeigt werden soll.
 */
  PageNumber?: number;

/**
 * Anzahl der Einträge pro Seite. Maximal 100
 */
  PageSize?: number;
}

export function getAllFehlerlistenEintraege$Plain(http: HttpClient, rootUrl: string, params?: GetAllFehlerlistenEintraege$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<FehlerlistenEintrag>>> {
  const rb = new RequestBuilder(rootUrl, getAllFehlerlistenEintraege$Plain.PATH, 'get');
  if (params) {
    rb.query('Datum', params.Datum, {});
    rb.query('IsNeedsCorrection', params.IsNeedsCorrection, {});
    rb.query('Vorname', params.Vorname, {});
    rb.query('Nachname', params.Nachname, {});
    rb.query('PageNumber', params.PageNumber, {});
    rb.query('PageSize', params.PageSize, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<FehlerlistenEintrag>>;
    })
  );
}

getAllFehlerlistenEintraege$Plain.PATH = '/v1/buchungen/fehlerliste';
